<script>
    import { apiResults } from './store';
    import { Link } from "svelte-routing";
    import { fade } from 'svelte/transition';

    import IconifyIcon from '@iconify/svelte';
    import informationIcon from '@iconify-icons/mdi/information';


    let results;
    let co2KGPerYear;
    let flights;
    let carRides;
    let coffees;
    let error = '';

    let pageSizeReductionPercent = 15;
    let loadingSizeReduction = false;
    let sizeReductionResults;
    let showGreenHosterResults = false;

    let thresholds = {
        medium: 0.33,
        good: 0.66
    };

    let showInfoFlight = false;
    let showInfoCar = false;
    let showInfoCoffee = false;

    function toggleInfoFlight() {
        showInfoFlight = !showInfoFlight;
    }

    function toggleInfoCar() {
        showInfoCar = !showInfoCar;
    }

    function toggleInfoCoffee() {
        showInfoCoffee = !showInfoCoffee;
    }

    apiResults.subscribe(value => {
        
        let response;
        
        if(value) {
            response = JSON.parse(value);
        }
       
        console.log(response);
        error = '';

        if(response && !response.error){
            results = response;

            if(results.green){
                co2KGPerYear = getYearlyValue(results.statistics.co2.renewable.grams);
            } else {
                co2KGPerYear = getYearlyValue(results.statistics.co2.grid.grams);
            }
            
            flights = getFlights();
            carRides = getCarRides();
            coffees = getCoffees();
        } else {
            error = 'Fehler beim Abfragen der API';
        }

        
    });
    
    function getYearlyValue(co2Grams) {
        let monthlyPageVisits = 10000; // we can later set this to autoconfigure

        return co2Grams * monthlyPageVisits * 12/1000;
    }

    function formatNumber(n) {
        return Number.parseFloat(n).toFixed(2);
    }

    function getFlights() {
        const co2KGPerFlight =  76; // flight from CGN to FRA, average airline, calculated with: https://www.atmosfair.de/

        return co2KGPerYear/co2KGPerFlight;
    }

    function getCarRides() {
        const km = 23; // Köln -> Bonn
        const co2KGPer1KM =  0.2; // 1 Person, 7.2L/100km, Benziner
        let co2PerRide = km * co2KGPer1KM;

        return co2KGPerYear/co2PerRide;
    }

    function getCoffees(co2GramsPerYear) {
        const co2KGPerCoffee = 0.021; // https://www.ecowatch.com/coffees-invisible-carbon-footprint-1882175408.html

        return co2KGPerYear/co2KGPerCoffee;
   }

   function simulateSizeReduction() {
       loadingSizeReduction = true;
       sizeReductionResults = '';

       let newsize = results.bytes - results.bytes * pageSizeReductionPercent / 100;
       let isGreen = results.green ? 1 : 0;

        console.log(newsize);
        console.log(results.bytes);

       getResult(`/api/data?bytes=${newsize}&green=${isGreen}`)
            .then( result => {
                sizeReductionResults = JSON.parse(result);
                console.log(sizeReductionResults);
                loadingSizeReduction = false;

                console.log(sizeReductionResults.statistics.co2.grid.grams);
                console.log(results.statistics.co2.grid.grams);
            });
   }

   async function getResult(url) {

        let response = await fetch(url);
        let text = await response.text();
		let data = text;
        return data;
    }
</script>
{#if error}
<div class="alt-bg error-prompt">
    <div>{error}</div>
    <p><Link to="/">Zurück</Link></p>
</div>
{/if}

{#if results}
<div class="alt-bg" style="padding-bottom: 3rem;">
    <div class="results__outer-gauge-box content-box alt-bg m-auto fit-content">
        <p>Ökologischer Fußabdruck für:</p>
        <h1 class="results-url">{results.url}</h1>

        <div class="results__gauge-bubble normal-bg round-corner">
            {#if results.cleanerThan < thresholds.medium }
                <img class="results-gauge" src="./img/gauge-red.png" alt="Eine Anzeige, deren Zeiger auf Rot steht."/>
            {:else if results.cleanerThan >= thresholds.medium && results.cleanerThan < thresholds.good }
                <img class="results-gauge" src="./img/gauge-yellow.png" alt="Eine Anzeige, deren Zeiger auf Gelb steht."/>
            {:else }
                <img class="results-gauge" src="./img/gauge-green.png" alt="Eine Anzeige, deren Zeiger auf Grün steht."/>
            {/if} 

            <div>
                <p class="big-text">Besser als <strong class="highlighted-text">{ Math.round(results.cleanerThan * 100) }%</strong> aller getesteten Webseiten.</p>   
            </div>   
        </div>
    </div>

    <div class="content-box energy-feedback">
        {#if results.green}
            <p class="m-auto w-50 big-text">
                Diese Website scheint über <strong>grüne Energie</strong> zu laufen!
            </p>
        {:else}
            <p class="m-auto w-50 big-text">
                Diese Website scheint leider <strong class="highlighted-text">nicht über grüne Energie</strong> zu laufen!
            </p>
        {/if}
    </div>
</div>

<div class="content-box flex-col">

    <p class="m-auto w-50 big-text center-box">
            {#if results.green}
                Bei jedem Seitenaufruf werden rund <strong class="highlighted-text">{formatNumber(results.statistics.co2.renewable.grams)} g CO2</strong> ausgestoßen!
            {:else}
                Bei jedem Seitenaufruf werden rund <strong class="highlighted-text">{formatNumber(results.statistics.co2.grid.grams)} g CO2</strong> ausgestoßen!
            {/if}
        </p>

    <p class="m-auto w-50 big-text center-box" style="margin-top: 1em;">
        1 Jahr mit 10.000 Seitenaufrufen im Monat produziert etwa <strong class="highlighted-text">{formatNumber(co2KGPerYear)} kg CO2</strong> , das entspricht:
    </p>
    
    <div class="measures">
        <div class="bubble normal-bg results-bubble m-auto">
            <div class="results-bubble-title">
                <p class="big-text"><strong class="highlighted-text">{formatNumber(flights)} Flügen</strong> von Köln nach Frankfurt 
                </p> 
                <button class="icon-btn" on:click={toggleInfoFlight}><IconifyIcon icon={informationIcon} height="32px"/></button>
            </div>
            {#if showInfoFlight}
                <div class="normal-bg info-box" in:fade out:fade>
                    Ausgehend von dem Emmisionswert für eine durchschnittliche Airline berechnet mit <a href="https://www.atmosfair.de/en/offset/flight/">Atmosfair</a>
                </div>
            {/if}
            <div class="measure-img">
                {#each Array(Math.ceil(flights)) as _, i}
                <img class="measure-img--plane" src="/img/plane.png" alt="">
                {/each}
            </div>
        </div>

        <div class="bubble normal-bg results-bubble m-auto">
            <div class="results-bubble-title">
                <p class="big-text"><strong class="highlighted-text">{Math.ceil(carRides)} Fahrten</strong> von Köln nach Hamburg</p>
                <button class="icon-btn" on:click={toggleInfoCar}><IconifyIcon icon={informationIcon} height="32px"/></button>
            </div>

            {#if showInfoCar}
            <div class="normal-bg info-box" in:fade out:fade>
                Fahrt mit 1 Person in einem Benziner mit einem durchschnittlichen Vebrauch von 7.2L/100km.
            </div>
            {/if}

            <div class="measure-img">
                {#each Array(Math.ceil(carRides)) as _, i}
                <img class="measure-img--car" src="/img/car.png" alt="">
                {/each}
            </div>
        </div>

        <div class="bubble normal-bg results-bubble m-auto">
            <div class="results-bubble-title">
                <p class="big-text"><strong class="highlighted-text">{Math.ceil(coffees)} Tassen</strong> Kaffee. Das wären {Math.ceil(coffees/365)} Tassen am Tag.</p>
                <button class="icon-btn" on:click={toggleInfoCoffee}><IconifyIcon icon={informationIcon} height="32px"/></button>
            </div>

            {#if showInfoCoffee}
            <div class="normal-bg info-box" in:fade out:fade>
                Basierend auf Werten von <a href="https://www.ecowatch.com/coffees-invisible-carbon-footprint-1882175408.html">Ecowatch</a>
            </div>
            {/if}

            <div class="measure-img">
                <!-- Tassen durch 10 teilen, damit es nicht so extrem viele sind, aber die dimension bleibt  -->
                {#each Array(Math.ceil(coffees/10)) as _, i} 
                <img class="measure-img--coffee" src="/img/coffee.png" alt="">
                {/each}
            </div>
        </div>
    </div>
</div>

<div class="content-box flex-col alt-bg">
    <div class="center-box facts-inner-wrapper">
        <h2>Das können Sie verbessern</h2>

        <ul class="tipps">
            <li>
                <p>1. Bilder reduzieren</p> 
                <div class="fact-bubble round-corner">Versuchen Sie die Anzahl, Größe und Qualität der Bilder auf Ihrer Seite so weit es geht zu verringern</div>
            </li>
            <li>
                <p>2. Videos optimieren</p> 
                <div class="fact-bubble round-corner">Wenn Ihre Seite Videos enthält versuchen Sie hier ebenfalls die Länge, Format und Auflösung gering zu halten. Deaktivieren Sie auch Autoplay, so dass diese nur für interessierte Benutzer:innen geladen werden</div>
            </li>
            <li>
                <p>3. Weniger Schriftarten</p> 
                <div class="fact-bubble round-corner">Versuchen Sie die Anzahl der verwendeten Schriftarten gering zu halten. Viele unterschiedliche Schriftarten oder größere Schrifttypen können auch schnell zu größeren Datenmengen führen</div>
            </li>
        </ul>

        <div class="bubble info-bubble">
            <p>Alle oben genannten Maßnahmen haben einen Einfluss auf Ihre <strong>Seitengröße</strong>.</p>

            <p>Simulieren Sie wie sich eine <strong>Reduktion der Seitengröße</strong> bei Ihrer Seite auswirkt:</p>

            {#if !loadingSizeReduction }
            <label>
                <input type=radio bind:group={pageSizeReductionPercent} value={15}>
                15%
            </label>

            <label>
                <input type=radio bind:group={pageSizeReductionPercent} value={25}>
                25%
            </label>

            <label>
                <input type=radio bind:group={pageSizeReductionPercent} value={50}>
                50%
            </label>

            <button on:click={simulateSizeReduction} style="margin-top: 1em;">Simulieren</button>
            {:else }
            <p>Loading...</p>
            {/if}

            {#if sizeReductionResults}
                <p style="padding-right:1em;">Bei einer Reduktion der Seitengröße um <strong>{pageSizeReductionPercent}%</strong> würden pro Seitenaufruf <strong>{formatNumber(results.statistics.co2.grid.grams - sizeReductionResults.statistics.co2.grid.grams)} g CO2 weniger</strong> ausgestoßen.</p>

                <p>Das wären bei 10.000 Aufrufen im Monat <strong>{formatNumber((results.statistics.co2.grid.grams - sizeReductionResults.statistics.co2.grid.grams) * 120)} kg CO2 weniger</strong> im Jahr.</p>
            {/if}
        </div>

        <ul class="tipps">
            <li>
                <p>4. Wechseln Sie zu einem grünen Webhoster</p> 
                <div class="fact-bubble round-corner">Fragen Sie ihren Hoster, ob ihr Server mit erneuerbaren Energien betrieben werden oder CO2 kompensiert wird.</div>
            </li>
        </ul>
        <div class="bubble info-bubble">
            {#if results.green}
                <p>Super! Sie verwenden bereits einen grünen Webhoster.</p>
            {:else}
                    <p style="padding-right:1em;">Bei einem Wechsel zu einem grünen Hoster würden pro Seitenaufruf <strong>{formatNumber(results.statistics.co2.grid.grams - results.statistics.co2.renewable.grams)} g CO2 weniger</strong>  ausgestoßen.</p>
            {/if}
        </div>

        <ul class="tipps">
        <li>
            <p>5. Optimieren Sie Ihre Webseite</p> 
            <div class="fact-bubble round-corner">Mithilfe von Tools wie Google PageSpeed Insights können Sie Ihre Seite analysieren und wertvolle Erkentnisse gewinnen, wie sich Ihre Seite noch weiter optimieren lässt. </div>
        </li>
   </ul>
    </div>
</div>

{/if}

<style>
    .error-prompt {
        padding: 3em;
        height: 50vh;
    }

    .icon-btn{
        background: none;
        color: var(--black);
        cursor: pointer;
        border: none;
    }

    button.icon-btn:focus{
        border: none;
    }

    .info-bubble{
        margin: 1rem auto !important;
        border: var(--ci-red) 4px solid;
    }

    .info-box {
        font-size: 12px;   
        padding: 0.5em;
        margin-bottom: 2em;
    }
    .results-bubble-title {
        display: flex;
    }

    .results-bubble-title p {
        margin-block-start: 0.4em;
    }

    .content-box.energy-feedback{
        margin: 0;
        text-align: center;
        padding-top: 0;
        padding-bottom: 0;
        font-size: 0.9rem;
        margin: auto;
    }

    @media only screen and (max-width: 424px) {
        .content-box.energy-feedback p{
            padding-left: 1em;
            padding-right: 1em;
        }
    }

    @media only screen and (min-width: 425px) and (max-width: 767px){
        .content-box.energy-feedback{
            width: 300px;
        }
    }

    @media only screen and (min-width: 425px) {
        .content-box.energy-feedback{
            padding: 0;
            font-size: medium;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1023px){
        .content-box.energy-feedback{
            width: 500px;
        }
    }

     @media only screen and (min-width: 1024px) {
        .content-box.energy-feedback{
            width: auto;
        }
    }

    @media only screen and (min-width: 1024px) {
        .facts-inner-wrapper{
            width: 600px !important;
        }
    }

    @media only screen and (max-width: 1023px) {
        .facts-inner-wrapper{
            width: auto !important;
        }
    }

    .center-box {
        width: auto;
    }

    @media only screen and (min-width: 425px) and (max-width: 767px){
        .center-box {
            width: 300px;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1023px){
        .center-box {
            width: 500px;
        }
    }


    @media only screen and (max-width: 767px){
        .big-text {
            font-size: 0.9rem;
        }
    }

    @media only screen and (max-width: 767px){
        h2 {
            font-size: 1.2rem;
        }
    }

    @media only screen and (min-width: 1024px) {
        .center-box{
            width: auto; 
            margin: auto;
        }
    }

    .results__outer-gauge-box{
        display: flex;
        flex-direction: column;
        padding: 2em; 
    }

    .results__gauge-bubble{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0.5em 1.5em; 
    }

    @media only screen and (max-width: 425px) {
        .results__gauge-bubble {
            font-size: 0.9em;
        }
    }

    @media only screen and (min-width: 1024px) {
        .results__gauge-bubble{
            flex-direction: row;
        }
    }

    @media only screen and (min-width: 426px) and (max-width: 767px){
        .results__gauge-bubble{
            width:300px;
        }
    }

    @media only screen and (min-width: 768px) {
        .results__gauge-bubble{
            width:500px;
        }
    }

    .results-gauge{
        width:200px;
    }

    @media only screen and (min-width: 768px) {
        .results-gauge{
            width:300px;
        }
    }

    .measure-img {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .measure-img--plane{
        width: 120px;
    }

    .measure-img--car{
        width: 50px;
    }

    @media only screen and (min-width: 768px) {
        .measure-img--car{
            width: 80px;
        }
    }

    .measure-img--coffee{
        width: 20px;
    }

    .measures{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    @media only screen and (min-width: 1024px) {
        .measures{
            flex-direction: row;
        }
    }

    .results-url{
        color: var(--ci-red);
        text-decoration: underline;
        margin-top: 0;
        margin-bottom: 2em;
        word-break: break-all;
        font-size: 1.2em;
    }

    @media only screen and (min-width: 1024px) {
        .results-url{
            font-size: 2em;
        }
    }

    .results-bubble{
        margin-top: 2em;
        background-color: var(--white);
    }

    @media only screen and (min-width: 426px) and (max-width: 767px) {
        .results-bubble{
            width: 300px;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1023px){
        .results-bubble{
            width:500px;
        }
    }

    @media only screen and (min-width: 1024px) and (max-width: 1800px){
        .results-bubble{
            width:33%;
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
    }

    @media only screen and (min-width: 1801px) {
        .results-bubble{
            width:500px;
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
    }

    .tipps{
        counter-reset: my-awesome-counter;
        list-style: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0;
        padding: 0;
    }

    .tipps li{
        counter-increment: my-awesome-counter;
        display: flex;
        align-items: center;
        margin: 1rem 0;
        flex-direction: column;
    }

    @media only screen and (min-width: 768px) {
        .tipps li {
            flex-direction: row;
        }
    }


    .tipps li:nth-child(even){
        flex-direction: column
    }

    @media only screen and (min-width: 768px) {
        .tipps li:nth-child(even){
            flex-direction: row-reverse;
        }
    }

    .tipps p {
        color: var(--ci-red);
        font-size: 1.5rem;
        font-weight: bold;
        display: inline-flex;
        margin: 0;
        line-height: unset;
        padding: 1.5em 1em;
    }

    @media only screen and (min-width: 768px) {
        .tipps li:nth-child(odd) p{
            text-align: right;
        }
    }


    .tipps .fact-bubble {
        width: auto;
        padding: 1.5em 2em;
        margin: 0 1em;
        background-color: var(--bg-color);
    }

</style>